import axios from "axios";

const loadButton = document.querySelector("#lookup-clinics");
const geolocateButton = document.querySelector("#geolocate-btn");
const searchForm = document.querySelector("#find-clinic-form");
const isSpain = document.body.classList.contains("siteLang-es");
const dpdDropOffForm = document.getElementById("cex-dropoff-form");

const ajaxLoadMore = () => {
  let searchInput = searchForm.querySelector("input");
  let searchString = searchInput.value;
  let outputContainer = document.querySelector(".results-output");
  let successMessage = document.querySelector("#successMessage");
  let noneFoundMessage = document.querySelector("#noneFoundMessage");
  outputContainer.scrollIntoView({ behavior: "smooth" });

  outputContainer.innerHTML =
    '<div class="loadbar">' +
    (isSpain ? "Cargando tiendas" : "Loading Stores") +
    "</div>";

  let params = new URLSearchParams();
  params.append("action", "geo_load_clinics");

  // If we are on the "store to drop off at" page then pass that through
  if (document.getElementById("bookingIn")) {
    params.append("bookingIn", true);
  }

  const geocodeAddress = (passedAddress) => {
    let geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: passedAddress }, function (results, status) {
      if (status === "OK") {
        let location = results[0].geometry.location;
        let latitude = location.lat();
        let longitude = location.lng();

        console.log("Latitude: " + latitude);
        console.log("Longitude: " + longitude);

        successfulAddressLookup(latitude, longitude);
      } else {
        console.error(
          "Geocode was not successful for the following reason: " + status
        );
      }
    });
  };

  const successfulAddressLookup = (lat, lng) => {
    params.append("geolatitude", lat);
    params.append("geolongitude", lng);

    axios
      .post("/wp-admin/admin-ajax.php", params)
      .then((res) => {
        if (res.data && res.data.data) {
          if (successMessage) {
            successMessage.classList.remove("hidden");
          } else {
            outputContainer.innerHTML =
              '<div class="stores-result-content"><div class="content-wrap"><h3 class="medium-heading gradient-text mg-bt-reg centre-text">' +
              (isSpain
                ? "Aquí están tus tiendas más cercanas"
                : "Here are your nearest stores") +
              '</h3><p class="body-large-light centre-text">' +
              (isSpain
                ? "Tenemos tiendas en todo el país, por lo que nunca estamos demasiado lejos."
                : "We have stores across the country, so we are never too far away.") +
              "</p></div></div>";
          }
          //outputContainer.innerHTML += res.data.data;

          console.info("Response 2", res.data);
          outputContainer.innerHTML += res.data.data; //JSON.stringify(res.data.data, null, 2);

          // Store Drop off goodies
          console.info("Store drop off code loaded");
          outputContainer
            .querySelectorAll("button[data-store-dropoff-id]")
            .forEach((btn) => {
              console.info("adding store on click", btn);
              btn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                const storeLocationID = e.currentTarget.dataset.storeDropoffId;
                console.info("Selected store id " + storeLocationID);

                const formContainer =
                  document.getElementById("cex-form-container");
                formContainer.style.display = "block";
                setTimeout(() => {
                  formContainer.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }, 300);

                const storeLocationIDInput =
                  formContainer.querySelector("#store-locationID");
                if (storeLocationIDInput) {
                  storeLocationIDInput.value = storeLocationID;
                }
              });
            });
        } else {
          // No more posts to load
          if (noneFoundMessage) {
            noneFoundMessage.classList.remove("hidden");
          } else {
            outputContainer.innerHTML =
              '<div class="no-stores content-wrap"><h3 class="medium-heading gradient-text mg-bt-reg centre-text">' +
              (isSpain ? "No se encontraron tiendas" : "No stores found") +
              '</h3><p class="body-large-light centre-text">' +
              (isSpain
                ? "No parece que tengamos una tienda cerca de su ubicación. Póngase en contacto y podremos averiguar cómo hacernos llegar su artículo."
                : "It does not look like we have a store close to your location. Get in touch and we can work out how to get your item to us.") +
              "</p></div>";
          }
        }
      })
      .then(() => {
        // Load in new elements with fade
        let loadedItems = document.querySelectorAll(".loaded-ajax");
        Array.from(loadedItems).forEach((item) => {
          setTimeout(() => {
            item.classList.remove("loaded-ajax");
          }, 50);
        });
      });
  };

  // Initialise
  geocodeAddress(searchString);
};

const ajaxGeoLoadMore = () => {
  let outputContainer = document.querySelector(".results-output");
  let params = new URLSearchParams();

  params.append("action", "geo_load_clinics");

  // If we are on the "store to drop off at" page then pass that through
  if (document.getElementById("bookingIn")) {
    params.append("bookingIn", true);
  }

  outputContainer.innerHTML = '<div class="loadbar">Loading Stores2</div>';
  outputContainer.scrollIntoView({ behavior: "smooth" });

  const geoOptions = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  const geoError = () => {
    return false;
  };

  const successfulGeo = (location) => {
    params.append("geolatitude", location.coords.latitude);
    params.append("geolongitude", location.coords.longitude);

    axios
      .post("/wp-admin/admin-ajax.php", params)
      .then((res) => {
        console.info("Store location");
        if (res.data && res.data.data) {
          if (successMessage) {
            successMessage.classList.remove("hidden");
          } else {
            outputContainer.innerHTML =
              '<div class="stores-result-content"><div class="content-wrap"><h3 class="medium-heading gradient-text mg-bt-reg centre-text">' +
              (isSpain
                ? "Aquí están tus tiendas más cercanas"
                : "Here are your nearest stores") +
              '</h3><p class="body-large-light centre-text">' +
              (isSpain
                ? "Tenemos tiendas en todo el país, por lo que nunca estamos demasiado lejos."
                : "We have stores across the country, so we are never too far away.") +
              "</p></div></div>";
          }
          console.info("Response", res.data);
          outputContainer.innerHTML += JSON.stringify(res.data.data, null, 2);
        } else {
          // No more posts to load

          if (noneFoundMessage) {
            noneFoundMessage.classList.remove("hidden");
          } else {
            outputContainer.innerHTML =
              '<div class="no-stores content-wrap"><h3 class="medium-heading gradient-text mg-bt-reg centre-text">' +
              (isSpain ? "" : "No stores found") +
              '</h3><p class="body-large-light centre-text">' +
              (isSpain
                ? "No parece que tengamos una tienda cerca de su ubicación. Póngase en contacto y podremos averiguar cómo hacernos llegar su artículo."
                : "It does not look like we have a store close to your location. Get in touch and we can work out how to get your item to us.") +
              "</p></div>";
          }
        }
      })
      .then(() => {
        // Load in new elements with fade
        let loadedItems = document.querySelectorAll(".loaded-ajax");
        Array.from(loadedItems).forEach((item) => {
          setTimeout(() => {
            item.classList.remove("loaded-ajax");
          }, 50);
        });
      });
  };

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      successfulGeo,
      geoError,
      geoOptions
    );
  } else {
    // cancelled
  }
};

const hideMessages = () => {
  if (successMessage) {
    successMessage.classList.append("hidden");
  }
  if (noneFoundMessage) {
    noneFoundMessage.classList.append("hidden");
  }
};

document.addEventListener("DOMContentLoaded", () => {
  if (typeof loadButton != "undefined" && loadButton != null) {
    loadButton.addEventListener("click", (e) => {
      e.preventDefault();
      ajaxLoadMore();
    });
  }

  if (typeof searchForm != "undefined" && searchForm != null) {
    searchForm.addEventListener("submit", (e) => {
      hideMessages();
      e.preventDefault();
      ajaxLoadMore();
    });
  }

  if (typeof geolocateButton != "undefined" && geolocateButton != null) {
    geolocateButton.addEventListener("click", (e) => {
      hideMessages();
      e.preventDefault();
      ajaxGeoLoadMore();
    });
  }

  if (typeof dpdDropOffForm != "undefined" && dpdDropOffForm != null) {
    dpdDropOffForm.addEventListener("submit", () => {
      hideMessages();
      const submitLoadingBar = document.getElementById("submit-loadbar");
      submitLoadingBar.style.display = "flex";
    });
  }
});
